import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import Logo from 'assets/images/access-logo.svg'
import productPreview from 'assets/images/access-product-preview.png'

import styles from './AccessPage.module.scss'

const AccessPage = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation('access')

  return (
    <div className={styles.access}>
      <main className={styles.panel}>
        <div className={styles.header} />
        <div className={styles.content}>
          <Logo className={styles.logo} aria-label="Innkeepr" role="img" />
          {children}
        </div>
        <footer className={styles.footer}>
          <span>{t('copyright', { year: new Date().getFullYear() })}</span>
          <div>
            <a href={t('urls.privacy')}>{t('privacy')}</a>
            <a href={t('urls.terms')}>{t('terms')}</a>
            <a href={t('urls.imprint')}>{t('imprint')}</a>
          </div>
        </footer>
      </main>
      <aside className={styles.preview} aria-hidden="true">
        <img src={productPreview} alt="" />
      </aside>
    </div>
  )
}

export default AccessPage
